import { createApiSlice } from "@common";
import { CRUD_LEAD_QUALIFICATION_MATURITY } from "@routes";

const apiConfig = [
  {
    name: "addLeadQualificationMaturity",
    method: "post",
    url: CRUD_LEAD_QUALIFICATION_MATURITY,
    stateKey: "message",
  },
  {
    name: "getLeadQualificationMaturity",
    method: "get",
    url: CRUD_LEAD_QUALIFICATION_MATURITY,
    stateKey: "data",
  },
  {
    name: "updateLeadQualificationMaturity",
    method: "put",
    url: CRUD_LEAD_QUALIFICATION_MATURITY,
    stateKey: "message",
  },
  {
    name: "deleteLeadQualificationMaturity",
    method: "delete",
    url: CRUD_LEAD_QUALIFICATION_MATURITY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "leadQualificationMaturity",
  apiConfig,
  customReducers);
const leadQualificationMaturitySlice = slice;

export default leadQualificationMaturitySlice.reducer;

export const {
  addLeadQualificationMaturity,
  getLeadQualificationMaturity,
  updateLeadQualificationMaturity,
  deleteLeadQualificationMaturity,
} = thunks;

export const { rowSelect } = actions;
